/*
 * File: ClientsList.tsx
 * Project: a-a
 * File Created: Saturday, 21st December 2024 9:43:55 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Wednesday, 15th January 2025 8:48:06 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ClientColumnGrid from './ClientColumnGrid';
import ClientRowGrid from './ClientRowGrid';
import { ClientService } from '../../../service/client.service';
type ClientData = {
  clients: [
    {
      Name: string;
      AccountId: string;
      closedDealAmount: string | null;
      openDealAmount: string | null;
      category: string | null;
    },
  ];
};
type ClientListProps = {
  layout: 'column' | 'row';
  category: string;
  data: ClientData;
  loading: boolean;
};

const ClientsList = ({ layout, category, data, loading }: ClientListProps) => {
  return (
    <Box>
      {layout === 'column' ? (
        <ClientColumnGrid clients={data} category={category} loading={loading} />
      ) : (
        <ClientRowGrid clients={data} category={category} loading={loading} />
      )}
    </Box>
  );
};

export default ClientsList;
